// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saturne-page {
  min-height: 100vh;
  background: #f7f8fb;
}

.saturne-page .page {
  background: #f7f8fb;
}

.saturne-page--wide .main,
.saturne-page--wide .titleContainer {
  width: min(96%, 1680px);
}

.saturne-page--wide .main {
  align-items: flex-start;
}

@media (max-width: 680px) {
  .saturne-page--wide .main,
  .saturne-page--wide .titleContainer {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SaturnePage/SaturnePage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;;IAEE,WAAW;EACb;AACF","sourcesContent":[".saturne-page {\n  min-height: 100vh;\n  background: #f7f8fb;\n}\n\n.saturne-page .page {\n  background: #f7f8fb;\n}\n\n.saturne-page--wide .main,\n.saturne-page--wide .titleContainer {\n  width: min(96%, 1680px);\n}\n\n.saturne-page--wide .main {\n  align-items: flex-start;\n}\n\n@media (max-width: 680px) {\n  .saturne-page--wide .main,\n  .saturne-page--wide .titleContainer {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
